import React from 'react';
import { useCurrentAcceptance } from '../../../../services/queries/acceptanceData';
import styles from './index.module.scss';

const deskIdAdapter = (desk) => desk.id || desk.deskId;
const deskNameAdapter = (desk) => desk.name || desk.deskName;

const DeskTags = () => {
  const acceptance = useCurrentAcceptance();

  return !acceptance?.desks?.length ? (
    <EmptyBlock />
  ) : (
    <Content data={acceptance.desks} />
  );
};

export default DeskTags;

function EmptyBlock() {
  return <span>Нет данных</span>;
}

function Content({ data }) {
  return (
    <div className={styles.root}>
      {data.map((desk) => (
        <button key={deskIdAdapter(desk)} className={styles.tag}>
          {deskNameAdapter(desk)}
        </button>
      ))}
    </div>
  );
}
